import { render } from "./OltpConfigEasyMode.vue?vue&type=template&id=1dca101a&scoped=true"
import script from "./OltpConfigEasyMode.vue?vue&type=script&lang=js"
export * from "./OltpConfigEasyMode.vue?vue&type=script&lang=js"

import "./OltpConfigEasyMode.vue?vue&type=style&index=0&id=1dca101a&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dca101a"]])

export default __exports__